import { BaseEntity } from '../../xform-compat';
import { HeadlineTypeEnum } from '../enums/headline-type.enum';
import { CompanyBasic } from './company/company-basic.model';


export class Headline implements BaseEntity {
  id: number;
  title: string;
  publishDate: string;
  referenceUrl: string;
  headlineType: HeadlineTypeEnum;
  description: string;
  previewDescription: string;
  ticker: string;
  companies: Array<CompanyBasic>;
  /** Backend-assigned classification labels for this headline (zero or more). */
  categories?: Array<string>;
}
